/**
 * Typed access to the Vite environment.
 *
 * Everything here is compiled into the bundle at build time, so nothing secret
 * belongs in it. The access token used to live here — baked into every build
 * and served to anyone who opened devtools. Tokens now come from `/auth/login`
 * at runtime and live in `tokenStore`, which leaves a single public API URL as
 * the only build-time input.
 */
export const env = {
  apiBaseUrl: (import.meta.env.VITE_APP_API_BASE_URL ?? '').replace(/\/+$/, ''),
  isDev: import.meta.env.DEV,
  /**
   * Whether the media kit is part of this build: its nav item, its editor and
   * the public `/kit/:slug` page. Only the literal `true` turns it on.
   *
   * It mirrors `MEDIA_KIT_ENABLED` on the API, which answers 404 for the whole
   * feature while it is off — so a build with this on against an API with it
   * off shows an explanation, not a broken screen.
   */
  mediaKitEnabled: import.meta.env.VITE_APP_MEDIA_KIT_ENABLED === 'true',
  /**
   * Whether the Analytics screens are part of this build: the nav item, the
   * overview, the post ledger, best times, the client report, and the strip
   * on the home screen. Only the literal `true` turns it on.
   *
   * It mirrors `ANALYTICS_ENABLED` on the API, which answers 404 for every
   * analytics route while it is off.
   */
  analyticsEnabled: import.meta.env.VITE_APP_ANALYTICS_ENABLED === 'true',
};

/** Matches API_PREFIX in the backend's project.constant.ts. */
export const API_PREFIX = 'api/v1';
export const API_SECURED_PREFIX = `${API_PREFIX}/secured`;
export const API_PUBLIC_PREFIX = `${API_PREFIX}/public`;

export const TOKEN_STORAGE_KEY = 'zaag-social.token';
/** Which workspace the app is currently showing. */
export const WORKSPACE_STORAGE_KEY = 'zaag-social.workspaceId';
export const THEME_STORAGE_KEY = 'zaag-social.theme';
/** Prefix; Home appends the workspace id, since setup is per workspace. */
export const SETUP_DISMISSED_STORAGE_KEY = 'zaag-social.setupDismissed';
